import has from 'lodash/has';
import { GET_VISTPERMISSIONS } from '../../constants/ActionTypes';

const initialState = {
  error: null,
  loaded: false,
  loading: false,
  // `data` stays as an array of group IDs for backwards compatibility
  // with existing components that call `data.includes(N)`. The richer
  // name-based permissions object is stored under `permissions`.
  data: [],
  groupNames: [],
  permissions: null,
};

// The endpoint historically returned a plain array of group IDs, e.g. [1, 13].
// After TASK-90 it returns an object:
//   { group_ids: [...], group_names: [...], permissions: {...} }
// Handle both shapes so the reducer is not tied to a single backend version.
function extractPayload(result) {
  if (Array.isArray(result)) {
    return { groupIds: [...result], groupNames: [], permissions: null };
  }
  if (result && typeof result === 'object') {
    return {
      groupIds: Array.isArray(result.group_ids) ? [...result.group_ids] : [],
      groupNames: Array.isArray(result.group_names)
        ? [...result.group_names]
        : [],
      permissions: result.permissions || null,
    };
  }
  return { groupIds: [], groupNames: [], permissions: null };
}

export function permissions(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_VISTPERMISSIONS}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    case `${GET_VISTPERMISSIONS}_SUCCESS`: {
      const payload = has(action, 'result')
        ? extractPayload(action.result)
        : { groupIds: [], groupNames: [], permissions: null };
      return {
        ...state,
        error: null,
        loading: false,
        loaded: true,
        data: payload.groupIds,
        groupNames: payload.groupNames,
        permissions: payload.permissions,
      };
    }
    case `${GET_VISTPERMISSIONS}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
        data: [],
        groupNames: [],
        permissions: null,
      };
    default:
      return state;
  }
}
